import styled from "styled-components";

const FooterWrapper = styled.footer`.aui-footer .aui-footer-logo.aui-footer-logo-100 {
      background: url(aha-logo-100.png) no-repeat;
      background-size: auto 100%;
  }`;

export default FooterWrapper;
